import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
const TaxBillIssuedInfo = ({ taxbill }) => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (taxbill) {
      if (taxbill.invTyp === '매출') {
        setMessage("재고가 출고 되었습니다.(매출 세금계산서)")
      } else {
        setMessage("재고로 입고되었습니다.(매입 세금계산서)")
      }
    }
  }, [taxbill])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: 1,

      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}><Typography variant="subtitle2" component="div">발행예정일</Typography></Grid>
        <Grid item xs={2}><Typography variant="body2" component="div">{taxbill?.reqPlanDt}</Typography></Grid>
        <Grid item xs={1}><Typography variant="subtitle2" component="div">발행요청 비고</Typography></Grid>
        <Grid item xs={3}><Typography variant="body2" component="div">{taxbill?.reqPlanTxt}</Typography></Grid>
        <Grid item xs={1}><Typography variant="subtitle2" component="div">발행요청여부</Typography></Grid>
        <Grid item xs={4}><Typography variant="body2" component="div">{taxbill?.reqPlanYn}</Typography></Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}><Typography variant="subtitle2" component="div">발행일</Typography></Grid>
        <Grid item xs={2}><Typography variant="body2" component="div">{taxbill?.reqCompDt}</Typography></Grid>
        <Grid item xs={1}><Typography variant="subtitle2" component="div">발행완료 비고</Typography></Grid>
        <Grid item xs={3}><Typography variant="body2" component="div">{taxbill?.reqCompTxt}</Typography></Grid>
        <Grid item xs={1}><Typography variant="subtitle2" component="div">발행완료 여부</Typography></Grid>
        <Grid item xs={4}><Typography variant="body2" component="div">{taxbill?.reqCompYn}</Typography></Grid>
      </Grid>
      {taxbill?.reqCompYn === 'Y' && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={12}><Typography variant="subtitle2" component="div" color="error">{message}</Typography></Grid>
        </Grid>
      )}
    </Box>
  );
};

export default TaxBillIssuedInfo;
